import { Pipe, PipeTransform } from '@angular/core';
import { NameFormatService } from 'app/services/name-format/name-format.service';

@Pipe({
  name: 'nameFormat',
  pure: false
})
export class NameFormatPipe implements PipeTransform {

  constructor(private nameFormatService: NameFormatService) {}

  transform(firstname: string, lastname: string): string {
    return this.nameFormatService.formatName(firstname, lastname);
  }
}
